import { paginationType } from 'global/Interfaces/Interfaces'
import TooltipWrapper from 'global/tooltip/TooltipWrapper'
import { useState } from 'react'
import { FiCreditCard } from 'react-icons/fi'
import {
  MdEditCalendar,
  MdHistory,
  MdOutlineReceiptLong,
  MdOutlineRemoveRedEye,
} from 'react-icons/md'
import { useDispatch, useSelector } from 'react-redux'
import { filterCreditSettlement } from 'redux/settlement-credit'
import Breadcrumb from '../../components/Breadcrumb/Breadcrumb'
import SwitchOptionTable from '../../components/OptionsTable/SwitchOptionTable'
import NewStaticTable from '../../components/staticTable/NewStaticTable'
import { getDay, getPrice } from '../../tools/functions/Methods'
import { CreditColumns } from './CreditColumns'
import DeliverySearchForm from './CreditSearch'
import BankDelivery from 'global/bank-delivery'
import LinkPayment from 'global/link-payment'
import PosPaymentModal from 'global/payment/posPayment'
import ImageView from 'pages/payment-mangement/views/image-view'
import PriceNotification from 'pages/payment-mangement/views/price-notification'
import { BiImageAdd } from 'react-icons/bi'
import { TbArrowsExchange } from 'react-icons/tb'
import { toast } from 'react-toastify'
import { hasPermission } from 'utils/HasPermission'
import Clearing from './clearing'
import ConsumerCredit from './consumer-credit-details'
import PaymentDetailCredit from './credit-payment-details'
import ExpireDate from './expire-date'
import History from './history'
import useExportExcel from './hooks/useExportExcel'
import SinglePayment from './single-payment'
import { usePayment } from './single-payment/usepayment'
import UserPayment from './user-payment'
import { createPaymentPrice, sync } from './utils'
import ExportExcelFormulaButton from './utils/export-excel-formula-action'
import { CiCreditCard2 } from 'react-icons/ci'

const CreditSettlement = () => {
  const dispatch = useDispatch()
  const { handleSubmit, refId } = usePayment()
  const { filter, settlementData, fetchPost } = useSelector(
    (state: any) => state.creditSettlement
  )
  const { pageNumbers } = useSelector((state: paginationType) => state.paginate)
  const [selectedRow, setSelectedRow] = useState<any>([])
  const [currentData, setCurrentData] = useState<any>()
  const { exportExcel, excelLoading } = useExportExcel(
    settlementData?.payload?.totalElements
  )

  const [openModal, setOpenModal] = useState({
    consumerCredit: false,
    deposit: false,
    bankDelivery: false,
    paymentDetail: false,
    userPayment: false,
    imageView: false,
    priceNotificationModal: false,
    posModal: false,
    linkPayment: false,
    expireData: false,
    history: false,
    clearing: false,
    depositToHub: false,
  })

  let data =
    settlementData?.payload?.content?.length !== 0
      ? settlementData?.payload?.content?.map((item: any, index) => {
          return {
            ...item,

            creditAmount: getPrice(item.creditAmount),
            hubName: item.creditRecipientHub?.name,
            settlementMonth:
              !!item.creditValidTo &&
              item.creditValidTo.year + '/' + item.creditValidTo.month,
            creditValidTo: !!item.creditValidTo && getDay(item.creditValidTo),
            creditExpirationDate:
              !!item.creditExpirationDate && getDay(item.creditExpirationDate),
            settlementDate:
              !!item.settlementDate && getDay(item.settlementDate),
            creditBalance: getPrice(item.creditBalance),
            // remainCredit: getPrice(item.creditAmount - item.usedCredit),
            receiveCredit: item.creditorHub?.name,
            totalPayment: getPrice(item.totalPayment),
            insurance: getPrice(
              item.findAllByConsignmentPriceFromHub?.insurance
            ),
            // totalPayment: getPrice(item.totalPayment),
            totalPayable: getPrice(
              item?.findAllByConsignmentPriceFromHub?.totalPayable
            ),

            hubShareAmount: getPrice(
              item?.findAllByConsignmentPriceFromHub?.hubShareAmount
            ),
            settlementStatus:
              item.settlementStatus === 1 ? 'پرداخت شده' : 'در انتظار پرداخت',
            usedCredit: item.findAllByConsignmentPriceFromHub.useCredit,
            tableusedCredit: getPrice(
              item.findAllByConsignmentPriceFromHub.useCredit
            ),
            cashAmount: getPrice(item.cashAmount),
            codAmount: getPrice(item.codAmount),
            totalCollection: getPrice(item.totalCollection),
            percentage: item.findAllByConsignmentPriceFromHub?.percentage,
            totalDepositToHub: getPrice(item.totalDepositToHub),
            operation: (
              <div className='flex w-full gap-3 justify-center'>
                {item?.bankReceiptDto && item?.bankReceiptDto?.length !== 0 && (
                  <button
                    className=' border-none	 text-[14px]  w-[20px] h-[20px] '
                    onClick={() => {
                      setCurrentData(item)
                      setOpenModal({ ...openModal, imageView: true })
                    }}
                  >
                    <TooltipWrapper textProps='مشاهده فیش ها'>
                      <MdOutlineRemoveRedEye className='w-full h-full' />
                    </TooltipWrapper>
                  </button>
                )}
                {hasPermission('refresh_credit') && (
                  <button
                    className=' border-none	 text-[14px]  w-[20px] h-[20px]   '
                    onClick={() => sync(item, refreshTable)}
                  >
                    <TooltipWrapper textProps='رفرش سقف اعتبار'>
                      <MdHistory size={20} />
                    </TooltipWrapper>
                  </button>
                )}
                {hasPermission('paycredit_bank_receipt') && (
                  <button
                    className=' border-none	 text-[14px]  w-[20px] h-[20px] '
                    onClick={() => {
                      setOpenModal({ ...openModal, bankDelivery: true })
                      setCurrentData(item)
                    }}
                  >
                    <TooltipWrapper textProps='افزودن تکی فیش بانکی'>
                      <BiImageAdd size={20} />
                    </TooltipWrapper>
                  </button>
                )}

                {/* <button
                  className=" border-none	 text-[14px]  w-[20px] h-[20px] "
                  onClick={() => {
                    setCurrentData(item)

                    setOpenModal({ ...openModal, consumerCredit: true })
                  }}
                >
                  <TooltipWrapper textProps="جزئیات اعتبار مصرفی">
                    <CiCircleInfo size={20} />
                  </TooltipWrapper>
                </button> */}
                <button
                  className=' border-none	 text-[14px]  w-[20px] h-[20px] '
                  onClick={() => {
                    setCurrentData(item)
                    setOpenModal({ ...openModal, paymentDetail: true })
                  }}
                >
                  <TooltipWrapper textProps='جزئیات پرداخت ها'>
                    <MdOutlineReceiptLong size={20} />
                  </TooltipWrapper>
                </button>
                <button
                  className=' border-none	 text-[14px]  w-[20px] h-[20px] '
                  onClick={() => {
                    setCurrentData(item)
                    setOpenModal({ ...openModal, userPayment: true })
                    // handleSubmit(item);
                  }}
                >
                  <TooltipWrapper textProps={'واریز وجه'}>
                    <FiCreditCard size={20} />
                  </TooltipWrapper>
                </button>
                {hasPermission('credit_setellment_date_edit') && (
                  <button
                    className=' border-none	 text-[14px]  w-[20px] h-[20px] '
                    onClick={() => {
                      setCurrentData(item)
                      setOpenModal({ ...openModal, expireData: true })
                      // handleSubmit(item);
                    }}
                  >
                    <TooltipWrapper textProps={'ویرایش موعد تسویه'}>
                      <MdEditCalendar className='w-full h-full' />
                    </TooltipWrapper>
                  </button>
                )}

                <button
                  className=' border-none	 text-[14px]  w-[20px] h-[20px] '
                  onClick={() => {
                    setCurrentData(item)
                    setOpenModal({ ...openModal, history: true })
                    // handleSubmit(item);
                  }}
                >
                  <TooltipWrapper textProps={'مشاهده سوابق'}>
                    <MdOutlineRemoveRedEye className='w-full h-full' />
                  </TooltipWrapper>
                </button>

                {hasPermission('creditsetelment_tahator') &&
                  item?.findAllByConsignmentPriceFromHub?.totalPayable < 0 && (
                    <button
                      className=' border-none	 text-[14px]  w-[20px] h-[20px] '
                      onClick={() => {
                        setCurrentData(item)
                        setOpenModal({ ...openModal, clearing: true })
                        // handleSubmit(item);
                      }}
                    >
                      <TooltipWrapper textProps={'تهاتر'}>
                        <TbArrowsExchange className='w-full h-full' />
                      </TooltipWrapper>
                    </button>
                  )}
                {hasPermission('creditsetelment-excelCalculationFormula') && (
                  <ExportExcelFormulaButton index={index} item={item} />
                )}

                {hasPermission('crediteSettelment_dipositTohub') &&
                  item?.findAllByConsignmentPriceFromHub?.totalPayable < 0 && (
                    <button
                      className=' border-none	 text-[14px]  w-[20px] h-[20px] '
                      onClick={() => {
                        setOpenModal({ ...openModal, depositToHub: true })
                        setCurrentData(item)
                      }}
                    >
                      <TooltipWrapper textProps='واریز بدهی به هاب'>
                        <CiCreditCard2 size={20} />
                      </TooltipWrapper>
                    </button>
                  )}
              </div>
            ),
          }
        })
      : []

  const refreshTable = () => {
    dispatch(
      filterCreditSettlement({
        ...filter,
        pageSize: 10,
        pageNumber: pageNumbers,
      }) as any
    )
  }
  const ToggleOptions = [
    // {
    //   handleClick: async () => {
    //     checkIsSelectedRow(selectedRow)
    //     checkSameHub(selectedRow)
    //     setOpenModal({ ...openModal, priceNotificationModal: true })
    //   },
    //   name: "اتصال به درگاه ",
    // },
    // {
    //   handleClick: () => {
    //     checkIsSelectedRow(selectedRow)
    //     checkSameHub(selectedRow)
    //     setOpenModal({ ...openModal, posModal: true })
    //   },
    //   name: 'اتصال به کارتخوان ',
    // },
    // {
    //   handleClick: () => {
    //     if (selectedRow.length !== 1) {
    //       toast.error('امکان ثبت فیش فقط برای یک مورد امکان پذیر است ')
    //       return
    //     }
    //     checkIsSelectedRow(selectedRow)
    //     checkSameHub(selectedRow)
    //     setOpenModal({ ...openModal, bankDelivery: true })
    //   },
    //   name: 'ثبت رسید بانکی',
    // },
    {
      handleClick: () => {
        if (selectedRow.length !== 1) {
          toast.error('امکان پرداخت فقط برای یک مورد امکان پذیر است ')
          return
        }
        setOpenModal({ ...openModal, linkPayment: true })
      },
      name: 'پرداخت از طریق لینک',
      permission: 'paycredit_paymentlink',
    },
  ]
  // const convertConsumeSelectedRow = (values) => {
  //   return values.map((value) => ({
  //     date: value.creditValidTo,
  //     hub: value?.hub?.name || "هاب تهزلن",
  //     id: value.id,
  //     price: value.usedCredit,
  //   }));
  // };

  return (
    <>
      <Breadcrumb curentPage='تسویه اعتبار' beforePage='اعتبار' />
      {/* <span>هاب: </span>{" "}
      <span className=" font-semibold">{userInfo?.currenthub?.label}</span> */}
      <DeliverySearchForm />
      <SwitchOptionTable
        accessPage={[
          {
            code: 'A2',
            value: { ToggleOptions, text: 'پرداخت' },
          },
          // {
          //   code: "A63",
          //   value: () => setOpenModal({ ...openModal, deposit: true }),
          //   // permission: hasPermission("groupDeliveryoutofPlan"),
          // },

          // {
          //   code: "A63",
          //   value: () => setOpenModal({ ...openModal, history: true }),
          //   text: "مشاهده سوابق",
          //   // className: "bg-red",
          //   // permission: hasPermission("groupDeliveryoutofPlan"),
          // },
          {
            code: 'A1',
            value: {
              data: [],
              columns: CreditColumns,
              onclick: exportExcel,
              title: 'groupPayment',
              loading: excelLoading,
            },
          },
        ]}
      />
      <NewStaticTable
        data={data ? data : []}
        THWrapper={'whitespace-nowrap'}
        selectAble={true}
        pagination={settlementData?.payload?.totalElements}
        setselectedState={(value) => setSelectedRow(value)}
        selectedState={selectedRow}
        column={CreditColumns}
        loading={fetchPost}
        ignoreRedux={true}
        isSticky
      />
      {openModal.consumerCredit && (
        <ConsumerCredit
          open={openModal.consumerCredit}
          setOpen={setOpenModal}
          currentData={currentData}
        />
      )}
      <SinglePayment refId={refId} />

      {openModal.paymentDetail && (
        <PaymentDetailCredit
          open={openModal.paymentDetail}
          setOpen={setOpenModal}
          currentData={currentData}
        />
      )}
      <BankDelivery
        extraData={`(دوره تسویه: ${
          !!currentData?.creditValidTo &&
          currentData?.creditValidTo?.year +
            '/' +
            currentData?.creditValidTo?.month
        } /   هاب:${
          currentData?.creditRecipientHub?.name
        } /  اعتبار اول دوره : ${getPrice(currentData?.creditAmount)}) <br/>`}
        // extraData={selectedRow.map((row) => {
        //   return `(دوره تسویه: ${row.settlementMonth} /   هاب:${row.hubName} /  اعتبار اول دوره : ${row.creditAmount}) <br/>`
        // })}
        open={openModal.bankDelivery}
        refrenceList={
          currentData
            ? [{ id: currentData.id, text: currentData.creditorHubId }]
            : selectedRow.map((item) => ({
                id: item.id,
                text: item.creditorHubId,
              }))
        }
        setOpen={setOpenModal}
        refreshTable={refreshTable}
        type={{ id: 3 }}
        hub={currentData?.creditorHubId}
        // hub={selectedRow[0]?.creditorHubId}
      />
      {openModal.userPayment && (
        <UserPayment
          open={openModal.userPayment}
          setOpen={setOpenModal}
          submit={(item) => handleSubmit(item)}
          currentData={currentData}
        />
      )}
      {openModal.expireData && (
        <ExpireDate
          open={openModal.expireData}
          setOpen={setOpenModal}
          currentData={currentData}
          refreshTable={refreshTable}
        />
      )}
      {openModal.imageView && (
        <ImageView
          open={openModal.imageView}
          setOpen={setOpenModal}
          currentData={currentData}
        />
      )}

      {openModal.priceNotificationModal && (
        <PriceNotification
          open={openModal.priceNotificationModal}
          setOpen={setOpenModal}
          onClick={handleSubmit}
          payment={createPaymentPrice(selectedRow)}
        />
      )}
      {/* {openModal.posModal && ( */}
      <PosPaymentModal
        isOpen={openModal.posModal}
        setIsOpen={setOpenModal}
        paymentData={createPaymentPrice(selectedRow)}
        refreshTable={refreshTable}
      />
      {/* )} */}

      <LinkPayment
        open={openModal.linkPayment}
        setOpen={setOpenModal}
        payData={{
          hubId: selectedRow[selectedRow.length - 1]?.creditRecipientHub?.id,
          customerId: '',
          // debt: "",
          creditId: selectedRow[selectedRow.length - 1]?.id,
          mobile: '',
          price: '',
        }}
        api={'/consignment-api/payments/payment-links/hubs/credit'}
        type='credit'
        callBack={() => {
          toast.success('لینک با موفقیت ارسال شد')
          setSelectedRow([])
        }}
      />

      {openModal.history && (
        <History
          open={openModal.history}
          setOpen={setOpenModal}
          currentData={currentData}
        />
      )}
      {openModal.clearing && (
        <Clearing
          open={openModal.clearing}
          setOpen={setOpenModal}
          currentData={currentData}
          refreshTable={refreshTable}
        />
      )}
      {openModal.depositToHub && (
        <BankDelivery
          open={openModal.depositToHub}
          refrenceList={
            currentData
              ? [{ id: currentData.id, text: currentData.creditorHubId }]
              : selectedRow.map((item) => ({
                  id: item.id,
                  text: item.creditorHubId,
                }))
          }
          setOpen={setOpenModal}
          refreshTable={refreshTable}
          type={{ id: 3 }}
          hub={currentData?.creditorHubId}
          onCancel={() => {
            setOpenModal({ ...openModal, depositToHub: false })
          }}
          apiUrl='/consignment-api/bankReceipt/hubFish'
          title='واریز بدهی هاب'
        />
      )}
    </>
  )
}

export default CreditSettlement
